import { render, staticRenderFns } from "./adult_surveillance_details.vue?vue&type=template&id=7778e558&"
import script from "./adult_surveillance_details.vue?vue&type=script&lang=js&"
export * from "./adult_surveillance_details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports